import { Bits } from './bits';

export enum AccountsPermissions {
	CanAccessAccounts = Bits.Bit1,
	AccountsCanAccessReportsData = Bits.Bit2
}
